<script>
import DatePicker from './PaymentsDatePicker';

export default {
  name: 'DateFilters',
  components: {
    DatePicker,
  },
  props: {
    arrivalFromDate: {
      type: String,
      required: true,
    },
    arrivalToDate: {
      type: String,
      required: true,
    },
    paidDateFromDate: {
      type: String,
      required: true,
    },
    paidDateToDate: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    allowedDatesArrival(val) {
      return val >= this.arrivalFromDate;
    },
    allowedDatesPaid(val) {
      return val >= this.paidDateFromDate;
    },
  },
};
</script>

<template>
  <v-content class="ma-0 pa-0">
    <h2 class="text-xs-center">{{ $t('payments.filters.date') }}</h2>
    <v-divider class="date-filter__divider"/>
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs2 align-center d-inline-flex>
          <p
            :class="{ 'grey--text text--lighten-1': disabled }"
            class="font-weight-bold ma-0"
          >
            {{ $t('payments.filters.arrival') }}:
          </p>
        </v-flex>
        <v-flex xs3>
          <date-picker
            @updateFilter="$emit('updateFilterArrivalFromDate', $event)"
            :label="$t('payments.filters.from')"
            :date="arrivalFromDate"
            :disabled="disabled"
          />
        </v-flex>
        <v-flex xs3>
          <date-picker
            @updateFilter="$emit('updateFilterArrivalToDate', $event)"
            :label="$t('payments.filters.to')"
            :date="arrivalToDate"
            :allowedDates="allowedDatesArrival"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex xs2 align-center d-inline-flex>
          <p
             :class="{ 'grey--text text--lighten-1': disabled }"
              class="font-weight-bold ma-0"
          >
            {{ $t('payments.filters.paidDate') }}:
          </p>
        </v-flex>
        <v-flex xs3>
          <date-picker
            @updateFilter="$emit('updateFilterPaidDateFromDate', $event)"
            :label="$t('payments.filters.from')"
            :date="paidDateFromDate"
            :disabled="disabled"
          />
        </v-flex>
        <v-flex xs3>
          <date-picker
            @updateFilter="$emit('updateFilterPaidDateToDate', $event)"
            :label="$t('payments.filters.to')"
            :date="paidDateToDate"
            :allowedDates="allowedDatesPaid"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<style lang="scss">
  .date-filter {
    &__divider {
       margin-left: 30%;
       margin-right: 30%;
       margin-bottom: 15px;
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/payments/PaymentsDateFilters.vue